import * as React from 'react';
import { openAddCreditCardModal } from '@/redux/modules/modal';
import { PaymentProviders } from '@/enums';
import { recordAnalyticsForAddCreditCardPageView } from '@/redux/modules/analytics';
import { useAppDispatch } from '@/redux/hooks';
import { useLocation } from 'react-router-dom';
import { waitToDispatch } from '@/utils/waitToDispatch/waitToDispatch';
import AddCreditCardPageHeaderMeta from './AddCreditCardPageHeaderMeta';
import EnsureLoggedInContainer from '@/components/EnsureLoggedIn/EnsureLoggedInContainer';
import styled from 'styled-components';

const AddCreditCardPage = () => {
    const dispatch = useAppDispatch();
    const location = useLocation();

    React.useEffect(() => {
        dispatch(openAddCreditCardModal(PaymentProviders.Payrix));
        waitToDispatch(recordAnalyticsForAddCreditCardPageView, dispatch, location);
    }, [dispatch, location]);

    return (
        <EnsureLoggedInContainer>
            <StyledPageContainer>
                <AddCreditCardPageHeaderMeta />
            </StyledPageContainer>
        </EnsureLoggedInContainer>
    );
};

export default AddCreditCardPage;

const StyledPageContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-bottom: 70px;
`;
